import React from "react";
import { Tabs } from "antd";
import GeneralPanel from "./GeneralPanel";
import ApiPanel from "./ApiPanel";
import PropertiesPanel from "./PropertiesPanel";
import { setActiveSidebarTab } from "../../services/store";
import { useDispatch, useSelector } from "react-redux";

const SidebarPanel = ({ selectedElement, handlePropertyChange, isGlobal }) => {
  const dispatch = useDispatch();
  const { activeSidebarTab } = useSelector((state) => state.grid);

  const items = [
    {
      key: "data",
      label: "Data",
      children: (
        <GeneralPanel
          selectedElement={selectedElement}
          handlePropertyChange={handlePropertyChange}
          isGlobal={isGlobal}
        />
      ),
      visible: true,
    },
    {
      key: "properties",
      label: "Properties",
      children: (
        <PropertiesPanel
          selectedElement={selectedElement}
          handlePropertyChange={handlePropertyChange}
          isGlobal={isGlobal}
        />
      ),
      visible: true,
    },
    {
      key: "api",
      label: "API",
      children: <ApiPanel />,
      visible: localStorage.getItem("userRole") === "admin", // Only show API tab for admin users
    },
  ].filter((item) => item.visible);

  return (
    <div className="flex flex-col gap-2 bg-gray-50 border border-l-gray-200 p-2 w-[300px] shrink-0 h-full overflow-auto">
      <Tabs
        onChange={(key) => dispatch(setActiveSidebarTab(key))}
        type="card"
        activeKey={activeSidebarTab}
        items={items}
        size="small"
      />
    </div>
  );
};

export default SidebarPanel;
